import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Winners = Loadable(
  lazy(() => import("src/pages/admin/monthlyPrizes/winners"))
);
const Config = Loadable(
  lazy(() => import("src/pages/admin/monthlyPrizes/config"))
);

const monthlyPrizes = [
  {
    path: "monthly-prizes",
    children: [
      { element: <Navigate to="winners" />, index: true },
      { path: "winners", element: <Winners /> },
      { path: "config", element: <Config /> },
    ],
  },
];

export default monthlyPrizes;
